<script setup lang="ts">
/**
 * Футер — по прототипу DUSTAR-PRO-Redesign.dc.html: логотип, копирайт,
 * контакт, GitHub и подсказка про клавишу `/`.
 */
import { useI18n } from '@/composables/useI18n'

const { t } = useI18n()
const year = new Date().getFullYear()

const EMAIL = 'poledustaren@gmail.com'
</script>

<template>
  <footer class="app-footer">
    <div class="app-footer-inner">
      <div class="app-footer-brand">
        <span class="app-footer-logo">DUSTAR.PRO</span>
        <span class="app-footer-dot" aria-hidden="true"></span>
        <span class="kicker">© {{ year }}</span>
      </div>

      <div class="app-footer-links">
        <!-- rel=author размечает адрес как контакт автора сайта -->
        <a :href="`mailto:${EMAIL}`" rel="author" class="app-footer-email">{{ EMAIL }}</a>
        <a href="https://github.com" target="_blank" rel="noreferrer" class="app-footer-github">GitHub</a>
        <span class="kicker">{{ t('footer.nav') }}</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  border-top: 2px solid var(--color-divider);
  margin-top: auto;
}
.app-footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-6) var(--space-8) clamp(90px, 10vw, 24px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}
.app-footer-brand {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.app-footer-logo {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 15px;
  color: var(--color-neutral-700);
}
.app-footer-dot {
  width: 6px;
  height: 6px;
  background: var(--color-accent);
  display: block;
}
.app-footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-6);
}
.app-footer-email,
.app-footer-github {
  font-size: 14px;
  color: var(--color-text);
  text-decoration: none;
}

.app-footer-email:hover {
  color: var(--color-accent-700);
}
.app-footer-github:hover {
  color: var(--color-accent-700);
}
</style>
